export namespace UserRole {
  export enum SchoolValues {
    PERDIR = 'PERDIR',
    CPE = 'CPE',
    TEACHER = 'TEACHER',
    STUDENT = 'STUDENT'
  }

  export enum BackOfficeValues {
    ADMIN = 'ADMIN',
    EDU_ENGINEER = 'EDU_ENGINEER',
    CONTENT_APPROVER = 'CONTENT_APPROVER'
  }

  export enum Values {
    ADMIN = 'ADMIN',
    EDU_ENGINEER = 'EDU_ENGINEER',
    CONTENT_APPROVER = 'CONTENT_APPROVER',
    PERDIR = 'PERDIR',
    CPE = 'CPE',
    TEACHER = 'TEACHER',
    STUDENT = 'STUDENT'
  }

  export function label(authority: Values | SchoolValues | BackOfficeValues) {
    switch (authority) {
      case Values.ADMIN:
        return 'Administrateur'
      case Values.EDU_ENGINEER:
        return 'Ing. Pédagogique'
      case Values.CONTENT_APPROVER:
        return 'Approbateur de contenu'
      case Values.PERDIR:
        return 'Pers. Dir.'
      case Values.CPE:
        return 'CPE'
      case Values.TEACHER:
        return 'Professeur'
      case Values.STUDENT:
        return 'Étudiant'
      default:
        return 'Non défini'
    }
  }

  export const options = Object.values(Values).map((role) => ({
    value: role,
    label: label(role)
  }))

  export const schoolOptions = Object.values(SchoolValues).map((role) => ({
    value: role,
    label: label(role)
  }))

  export const backOfficeOptions = Object.values(BackOfficeValues).map((role) => ({
    value: role,
    label: label(role)
  }))

  export function isBackOfficeRole(role: any[]): boolean {
    return role.includes(BackOfficeValues.ADMIN)
      || role.includes(BackOfficeValues.EDU_ENGINEER)
      || role.includes(BackOfficeValues.CONTENT_APPROVER)
  }

  export function isSchoolRole(role: any[]): boolean {
    return (
      role.includes(SchoolValues.TEACHER) ||
      role.includes(SchoolValues.CPE) ||
      role.includes(SchoolValues.PERDIR) ||
      role.includes(SchoolValues.STUDENT)
    )
  }

  // Constantes pour le tri par ordre de déclaration
  const orderedSet = new Set(Object.values(UserRole.Values));
  const orderMap = Array.from(orderedSet).reduce<Record<string, number>>(
    (acc, val, idx) => ({ ...acc, [val as unknown as string]: idx }),
    {}
  );

  /**
   * Tri par ordre ordinal (déclaration) de l'Enum
   * @param roles
   */
  export function sort(roles: Values[] | SchoolValues[] | BackOfficeValues[]) {
    return roles.sort((a, b) => orderMap[a] - orderMap[b])
  }
}
